import BusinessHoursPage from './BusinessHoursPage';
export default BusinessHoursPage;
